export default __webpack_public_path__ + "static/media/logoAutosul.8c496ccb.png";